import React from 'react';

export function AvatarInfant(props) {
    return (
        <svg viewBox="0 0 80 106" {...props}>
            <path
                fillRule="evenodd"
                d="M78.058 105.782c.48-.165 1.42-2.217 1.198-4.49-.818-8.405-13.314-8.406-19.197-10.144-5.493-1.623-8.542-4.166-4.864-5.558 8.675-3.28 11.364-11.087 12.838-9.852 3.966-.09 5.784-.885 7.371-2.835 3.59-4.411 4.572-9.793 1.252-12.452-1.483-1.188-3.144.613-2.218-3.435 4.713-20.592-7.859-36.722-27.664-42.085-3.572-.968-7.175-1.983-6-6.767.218-.89 3.165-2.89 3.245.157.022.87.667 1.002 2.047-.774 2.364-3.041.81-6.068-2.623-7.171-2.267-.73-5-.434-6.951 1.21-3.411 2.54-3.291 6.233-1.689 8.037 2.108 2.371 4.834 4.09 1.083 4.511C14.161 18.509-.123 35.278 4.852 57.016c.926 4.048-.736 2.247-2.219 3.435-3.32 2.659-2.338 8.041 1.252 12.452 1.587 1.95 3.405 2.746 7.371 2.835 1.475-1.235 4.163 6.572 12.838 9.852 3.678 1.392.63 3.935-4.863 5.558C13.347 92.886.851 92.887.033 101.292c-.221 2.273.719 4.325 1.199 4.49h76.826z"
            />
        </svg>
    );
}
